import { AbstractControl } from "@angular/forms";
import { CommandService } from "~app/common/services/cqs/command.service";
import { CommandControlBinderBase } from "./command-control-binder-base";

export class CommandControlCollectionBinder extends CommandControlBinderBase {

    private originalValues: any[] = [];
    private addExpression: any;
    private removeExpression: any;
    private addCommandInstance: any;
    private removeCommandInstance: any;

    constructor(protected readonly targetId: number, protected readonly commandService: CommandService, private readonly control: AbstractControl) {
        super(commandService);
        this.control.valueChanges.subscribe(this.handleChanges.bind(this));
        commandService.commandsPushed.subscribe(this.onCommandsPushed.bind(this));
        this.setIntitalValueReference(this.control.value);
    }

    /**
     * @param commandClass CommandClass to be bound
     * @param mapExpression Either a setter function with the value from the form and the command as args, or just the name of the command property.
     */
    bindAdd(commandClass, mapExpression: string | ((value, command) => void)) {
        this.addExpression = mapExpression;
        this.addCommandInstance = this.getCommand(commandClass, this.targetId);
    }

    /**
     * @param commandClass CommandClass to be bound
     * @param mapExpression Either a setter function with the value from the form and the command as args, or just the name of the command property.
     */
    bindRemove(commandClass, mapExpression: string | ((value, command) => void)) {
        this.removeExpression = mapExpression;
        this.removeCommandInstance = this.getCommand(commandClass, this.targetId);
    }

    comperator = (a, b) => a.id === b.id;

    private onCommandsPushed() {
        this.setIntitalValueReference(this.control.value);
    }

    private setIntitalValueReference(value: any[]) {
        this.originalValues = [];
        if (!value) {
            return;
        }
        value.forEach(v => this.originalValues.push(Object.assign({}, v)));
    }

    private handleChanges(newValue: any[]) {
        this.clearCommands();
        if (!this.control.valid) {
            return;
        }
        this.addCommand(this.addCommandInstance, this.addExpression, this.getAdded(newValue));
        this.addCommand(this.removeCommandInstance, this.removeExpression, this.getRemoved(newValue));
    }

    private clearCommands() {
        this.clearCommand(this.addCommandInstance);
        this.clearCommand(this.removeCommandInstance);
    }

    private getAdded(newValue: any[]) {
        const added = [];
        newValue?.forEach(v => {
            if (!this.originalValues.find((ov) => this.comperator(v, ov))) {
                added.push(v);
            }
        });
        return added;
    }

    private getRemoved(newValue: any[]) {
        const removed = [];
        this.originalValues?.forEach(ov => {
            if (!newValue || !newValue.find((v) => this.comperator(v, ov))) {
                removed.push(ov);
            }
        });
        return removed;
    }
}
